import React, { useMemo, useState } from 'react'

import { AddToJobFolderModal } from 'components/AddToJobFolderModal'
import SelectedItemsBar from 'components/SelectedItemsBar'
import { analyticsTracker } from 'utils'

import { TYPE_FORMATTED_MIXPANEL } from './consts'
import { ItemsContext } from './context'

export function SelectedItemsListProvider({ children }) {
  const [selectedItemsBar, setSelectedItemsBar] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)

  const removeItem = item => {
    const provider = item?.provider
    const type = TYPE_FORMATTED_MIXPANEL?.[item?.type]
    const variables = {
      Name: item?.name,
      id: item?.id,
      Type: type,
      ...(type === 'Topic' && { topicId: item?.id }),
      ...(type === 'Subtopic' && { subtopicId: item?.id }),
      ...(provider && { Provider: provider }),
    }
    const { ITEM_REMOVED } = analyticsTracker.eventNames
    analyticsTracker.eventTrack(ITEM_REMOVED, variables)
    setSelectedItemsBar(prevState => {
      return prevState.filter(prevItem => prevItem.id !== item.id)
    })
  }

  const addItem = item => {
    const provider = item?.provider
    const type = TYPE_FORMATTED_MIXPANEL?.[item?.type]
    const eventParams = {
      Name: item?.name,
      id: item?.id,
      Type: type,
      ...(type === 'Topic' && { topicId: item?.id }),
      ...(type === 'Subtopic' && { subtopicId: item?.id }),
      ...(provider && { Provider: provider }),
    }

    const { ITEM_SELECTED } = analyticsTracker.eventNames
    analyticsTracker.eventTrack(ITEM_SELECTED, eventParams)

    setSelectedItemsBar(prevState => [item, ...prevState])
  }

  const resetItemsBar = () => {
    setSelectedItemsBar([])
  }

  const toggleModal = () => {
    setIsModalOpen(prevState => !prevState)
  }

  const propValue = useMemo(() => {
    return {
      selectedItemsBar,
      setSelectedItemsBar,
      addItem,
      removeItem,
      resetItemsBar,
      isModalOpen,
      toggleModal,
    }
  }, [isModalOpen, selectedItemsBar])

  return (
    <ItemsContext.Provider value={propValue}>
      {children}
      {isModalOpen && <AddToJobFolderModal setIsOpen={setIsModalOpen} isOpen />}
      {selectedItemsBar.length ? <SelectedItemsBar /> : null}
    </ItemsContext.Provider>
  )
}
